<core-main-router-outlet/>